import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PublicShell({ children }) {
  const { user } = useAuth();
  const isLoggedIn = !!user;

  return (
    <div className="min-h-screen arena-bg" data-testid="public-shell">
      <header className="border-b border-amber-900/30 bg-zinc-950/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to={isLoggedIn ? "/" : "/login"} className="font-cinzel text-amber-300 uppercase tracking-[0.2em] text-lg hover:text-amber-400 transition-colors">
            Lanista
          </Link>
          <Link to={isLoggedIn ? "/" : "/login"} data-testid="public-header-cta"
            className="font-cinzel uppercase tracking-wide text-[11px] sm:text-xs bg-amber-600 text-zinc-950 px-3 sm:px-4 py-2 hover:bg-amber-500 transition-colors">
            {isLoggedIn ? "Return to Ludus" : "Play Free"}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">{children}</main>
      <footer className="border-t border-amber-900/20 mt-8">
        <div className="max-w-3xl mx-auto px-4 py-6 text-center text-[11px] text-zinc-600">
          Lanista — Gladiator Manager · Recruit. Train. Conquer.
        </div>
      </footer>
    </div>
  );
}
